var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useLayoutEffect, useEffect } from 'react';
import { RadioButtonListStyles } from './RadioButtonListStyles';
import { RadioButton } from '../../molecules/RadioButton';
import { InputMessage } from '../../atoms/InputMessage';
export var RadioButtonList = function (_a) {
    var sections = _a.sections, className = _a.className, preFilled = _a.preFilled, onClick = _a.onClick, error = _a.error, _b = _a.tabFocusTrap, tabFocusTrap = _b === void 0 ? 0 : _b;
    var itemsRef = useRef([]);
    var _c = useState(preFilled), selected = _c[0], setSelected = _c[1];
    var _d = useState(error || ''), radioListError = _d[0], setRadioListError = _d[1];
    var _e = useState(0), listHeight = _e[0], setListHeight = _e[1];
    var _f = useState(0), listWidth = _f[0], setListWidth = _f[1];
    useEffect(function () {
        setRadioListError(error || '');
    }, [error]);
    var handleRadioClick = function (value, label) {
        setRadioListError('');
        setSelected(value);
        onClick && onClick(value, label);
    };
    useLayoutEffect(function () {
        var _a, _b;
        setListHeight(((_a = itemsRef.current[0]) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
        setListWidth(((_b = itemsRef.current[0]) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0);
    }, [sections]);
    return (_jsxs(RadioButtonListStyles, __assign({ className: className, error: radioListError, listHeight: listHeight, listWidth: listWidth }, { children: [_jsx("div", __assign({ className: "radio-list-container", ref: function (el) { return (itemsRef.current[0] = el); } }, { children: _jsx("div", __assign({ className: "error-banner" }, { children: sections.map(function (_a, i) {
                        var label = _a.label, value = _a.value;
                        return (_jsx("div", __assign({ className: "radio-list-item" }, { children: _jsx(RadioButton, { label: label, dataCy: "".concat(label.replace(' ', '-'), "-radio-button-label"), value: value, handleRadioClick: handleRadioClick, selected: selected, tabFocusTrap: tabFocusTrap }) }), "".concat(label, "-").concat(i)));
                    }) })) })), _jsx("div", __assign({ className: "radio-list-error-container" }, { children: radioListError && _jsx(InputMessage, { className: "radio-list-error-message", message: radioListError }) }))] })));
};
